import { L, } from './leaflet';
const L_latLng = L.latLng;
export { L_latLng, };
